import { Checkbox, Text } from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { observer } from "mobx-react-lite";

interface AlreadyInvoicedFilter {
  checked: boolean;
  onToggle: () => void;
}

const AlreadyInvoicedFilter = ({
  checked,
  onToggle,
}: AlreadyInvoicedFilter) => {
  return (
    <Checkbox defaultChecked={checked} onChange={() => onToggle()}>
      <Text fontSize="sm">
        <Trans>Don't show already invoiced items</Trans>
      </Text>
    </Checkbox>
  );
};

export default observer(AlreadyInvoicedFilter);
